// extracted by mini-css-extract-plugin
export default {"cardContainer":"Products_cardContainer__uEeTP"};